module.exports = __webpack_public_path__ + "img/instagram-seeklogo.com.16aab142.svg";